<template>
  <b-row>
    <b-col
      v-for="item in data"
      :key="item.icon"
      md="6"
      class="mb-2"
    >
      <b-media no-body>
        <b-media-aside class="mr-2">
          <b-avatar
            size="65"
            :variant="item.color"
          >
            <feather-icon
              size="32"
              :icon="item.icon"
            />
          </b-avatar>
        </b-media-aside>

        <b-media-body class="my-auto">
          <p class="font-weight-bolder mb-0">
            <div class="d-flex h3">
              {{ item.title }}
            </div>
            <b-card-text class="font-small-5 mb-0">
              {{ item.subtitle }}
              <b-spinner
                v-if="loading"
                class="align-middle mr-1 my-2"
                variant="secondary"
              />
            </b-card-text>
          </p>
        </b-media-body>
      </b-media>
    </b-col>
  </b-row>
</template>


<script>
import {
  BSpinner, BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'
export default {
  components: {
    BSpinner,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    countDocument: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      data: [],
    }
  },
  watch: {
    countDocument: {
      handler(newVal) {
        this.data = [
          {
            color: 'success',
            icon: 'FileIcon',
            title: newVal.totalDocument,
            subtitle: 'Total Document'
          },
          {
            color: 'primary',
            icon: 'DownloadIcon',
            title: newVal.totalDownload,
            subtitle: 'Total Download Document'
          },
        ]
      },
      immediate: true, // agar langsung dijalankan saat komponen dimount
      deep: true, // jika kamu ingin mengamati perubahan dalam objek
    }
  }
}
</script>
